import React, { useState } from "react";
import { FaFlag, FaTimes } from "react-icons/fa";
import "./PinMessageModal.css";

const REPORT_REASONS = [
  { value: "spam", label: "Spam or misleading" },
  { value: "harassment", label: "Harassment or hate speech" },
  { value: "inappropriate", label: "Inappropriate content" },
  { value: "violence", label: "Violence or threats" },
  { value: "other", label: "Other" },
];

const ReportMessageModal = ({ message, onConfirm, onClose }) => {
  const [selectedReason, setSelectedReason] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");

  const handleSubmit = () => {
    if (!selectedReason) {
      alert("Please select a reason for reporting");
      return;
    }

    onConfirm({
      reason: selectedReason,
      additionalInfo,
    });
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content report-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>
            <FaFlag /> Report Message
          </h3>
          <button onClick={onClose} className="btn-close-modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p>Why are you reporting this message?</p>

          {message.content && (
            <div className="message-preview">
              <p>"{message.content.substring(0, 100)}..."</p>
              <small>by {message.sender?.name || "Unknown"}</small>
            </div>
          )}

          <div className="report-options">
            {REPORT_REASONS.map((reason) => (
              <div
                key={reason.value}
                className={`report-option ${
                  selectedReason === reason.value ? "selected" : ""
                }`}
                onClick={() => setSelectedReason(reason.value)}
              >
                <input
                  type="radio"
                  id={reason.value}
                  name="report-reason"
                  value={reason.value}
                  checked={selectedReason === reason.value}
                  onChange={() => setSelectedReason(reason.value)}
                />
                <label htmlFor={reason.value}>{reason.label}</label>
              </div>
            ))}
          </div>

          <textarea
            className="report-textarea"
            placeholder="Additional information (optional)"
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
          />
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-cancel">
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="btn-confirm"
            disabled={!selectedReason}
          >
            Submit Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportMessageModal;
